import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=5c34ad72&scoped=true&"
import script from "./BusinessDetail.vue?vue&type=script&lang=ts&"
export * from "./BusinessDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDetail.vue?vue&type=style&index=0&id=5c34ad72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34ad72",
  null
  
)

export default component.exports